import FiveWTwoH from './edgeless/5W2H.json';
import SWOT_анализ from './edgeless/SWOT-анализ.json';
import Блок_схема from './edgeless/Блок-схема.json';
import КонцептуальнаяКарта from './edgeless/Концептуальная карта.json';
import ЦелиSMART from './edgeless/Цели SMART.json';
import CJMПокупкиНаушников from './edgeless/CJM Покупки наушников.json';
import LeanCanvas from './edgeless/Lean Canvas.json';
import КартаПутиКлиента from './edgeless/Карта пути клиента.json';
import КонцепцияFourP from './edgeless/Концепция 4P.json';
import МатрицаРисков from './edgeless/Матрица рисков.json';
import ОтчётПоРезультатамИсследованияНазвание from './edgeless/Отчёт по результатам исследования Название.json';
import ТайныйПокупательТранскрибация from './edgeless/Тайный покупатель транскрибация.json';
import ШаблонРаскадровка from './edgeless/Шаблон Раскадровка.json';
import АнализДанных from './edgeless/Анализ данных.json';
import Бизнес_план from './edgeless/Бизнес-план.json';
import ПростаяПрезентация from './edgeless/Простая презентация.json';
import ДиаграммаГанта from './edgeless/Диаграмма Ганта.json';
import ДиаграммаИсикавы from './edgeless/Диаграмма Исикавы.json';
import Календарь from './edgeless/Календарь.json';
import Канбан from './edgeless/Канбан.json';
import ПланированиеПроекта from './edgeless/Планирование проекта.json';

const templates = {
  'Брейншторм': [
    FiveWTwoH,
    SWOT_анализ,
    Блок_схема,
    КонцептуальнаяКарта,
    ЦелиSMART
  ],
  'Маркетинг': [
    CJMПокупкиНаушников,
    LeanCanvas,
    КартаПутиКлиента,
    КонцепцияFourP,
    МатрицаРисков,
    ОтчётПоРезультатамИсследованияНазвание,
    ТайныйПокупательТранскрибация,
    ШаблонРаскадровка
  ],
  'Презентация': [
    АнализДанных,
    Бизнес_план,
    ПростаяПрезентация
  ],
  'Управление проектом': [
    ДиаграммаГанта,
    ДиаграммаИсикавы,
    Календарь,
    Канбан,
    ПланированиеПроекта
  ]
}

function lcs(text1: string, text2: string) {
  const dp: number[][] = Array.from({ length: text1.length + 1 })
    .fill(null)
    .map(() => Array.from<number>({length: text2.length + 1}).fill(0));

  for (let i = 1; i <= text1.length; i++) {
    for (let j = 1; j <= text2.length; j++) {
      if (text1[i - 1] === text2[j - 1]) {
        dp[i][j] = dp[i - 1][j - 1] + 1;
      } else {
        dp[i][j] = Math.max(dp[i - 1][j], dp[i][j - 1]);
      }
    }
  }

  return dp[text1.length][text2.length];
}

export const builtInTemplates = {
  list: async (category: string) => {
    // @ts-expect-error type should be asserted when using
    return templates[category] ?? []
  },

  categories: async () => {
    return Object.keys(templates)
  },

  search: async(query: string) => {
    const candidates: unknown[] = [];
    const cates = Object.keys(templates);

    query = query.toLowerCase();

    for(let cate of cates) {
      // @ts-expect-error type should be asserted when using
      const templatesOfCate = templates[cate];

      for(let temp of templatesOfCate) {
        if(lcs(query, temp.name.toLowerCase()) === query.length) {
          candidates.push(temp);
        }
      }
    }

    return candidates;
  },
}
